<template>
  <div>
    <div class="row col-12 mb-2">
      <div>
        <span class="c-text-btn mb-2">{{ label }}</span>
      </div>
    </div>
    <div class="row-inputs-sellable-student-exam">
      <div>
        <c-input
          v-model="dateValue"
          label="Data"
          mask="##/##/####"
          :state="inputState"
          :info="inputInfo"
          @blur="changeDate"
        >
          <template slot="icon">
            <span class="datetimepicker-toggle">
              <span class="datetimepicker-toggle-button">
                <Icon
                  name="Calendar"
                  outline
                  color="var(--c-color-gray-300)"
                />
              </span>
              <q-popup-proxy
                class="datetimepicker-input"
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  v-model="dateValue"
                  mask="DD/MM/YYYY"
                  @input="changeDate"
                />
              </q-popup-proxy>
            </span>
          </template>
        </c-input>
      </div>
      <div>
        <c-input
          v-model="timeValue"
          label="Hora"
          mask="##:##"
          :state="inputState"
          @blur="changeTime"
        >
          <template slot="icon">
            <span class="datetimepicker-toggle">
              <span class="datetimepicker-toggle-button">
                <Icon
                  name="Clock"
                  outline
                  color="var(--c-color-gray-300)"
                />
              </span>
              <q-popup-proxy
                class="datetimepicker-input"
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-time
                  v-model="timeValue"
                  @input="changeTime"
                />
              </q-popup-proxy>
            </span>
          </template>
        </c-input>
      </div>
    </div>
  </div>
</template>

<script>
import { CInput, Icon } from '@estrategiahq/coruja-web-ui';

export default {
  name: 'SellableStudentExamFormItem',
  components: {
    CInput,
    Icon,
  },
  props: {
    label: { type: String, default: '', required: true },
    dateTime: { type: Date, default: null },
    error: { type: String, default: '' },
  },
  data: () => ({
    dateValue: '',
    timeValue: '',
    inputError: '',
    errorByProp: '',
    modifiedDateValue: false,
    modifiedTimeValue: false,
  }),
  computed: {
    inputState() {
      return this.errorByProp?.length > 1 || this.inputError?.length > 1
        ? 'ERROR'
        : 'DEFAULT';
    },
    inputInfo() {
      if (this.errorByProp?.length > 1 || this.inputError?.length > 1) {
        return {
          message: this.errorByProp || this.inputError,
          icon: 'error',
          iconFilled: true,
        };
      }
      return { message: '' };
    },
  },
  watch: {
    dateTime: {
      immediate: true,
      handler(value) {
        if (value) {
          const date = value.toLocaleDateString('pt-br');
          const time = value.toLocaleTimeString('pt-br').slice(0, 5);
          this.dateValue = date;
          this.timeValue = time;
          this.modifiedDateValue = true;
          this.modifiedTimeValue = true;
        }
      },
    },
    error: {
      immediate: true,
      handler(value) {
        if (value) {
          this.errorByProp = value;
        } else {
          this.errorByProp = '';
        }
      },
    },
  },
  methods: {
    emitInput() {
      if (this.dateValue && this.timeValue) {
        const strValue = `${this.formatDateShortToIso(this.dateValue)} ${this.timeValue}`;
        if (!Number.isNaN(Date.parse(strValue))) {
          const value = new Date(strValue);
          this.emitSuccessInput(value);
        } else {
          this.emitErrorInput();
        }
      } else if (this.modifiedDateValue && this.modifiedTimeValue) {
        this.emitErrorInput();
      }
    },
    emitErrorInput() {
      this.$emit('input', null);
      this.inputError = 'Data inválida';
    },
    emitSuccessInput(value) {
      this.$emit('input', value);
      this.inputError = '';
    },
    changeDate() {
      this.emitInput();
    },
    changeTime() {
      this.emitInput();
    },
    formatDateShortToIso(value) {
      return value.split('/').reverse().join('-');
    },
  },
};
</script>
<style>
.row-inputs-sellable-student-exam {
  display: grid;
  justify-content: space-between;
  grid-template-columns: calc(50% - 12px) calc(50% - 12px);
}

/* datepicker toggle */
.datetimepicker-toggle {
  display: inline-block;
  position: relative;
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.datetimepicker-toggle-button {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
.datetimepicker-input {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  box-sizing: border-box;
}
</style>
